// extracted by mini-css-extract-plugin
export default {"CookiesBanner":"CookiesBanner_CookiesBanner__fBELm","CookiesBanner__mobile":"CookiesBanner_CookiesBanner__mobile__JL8Jh"};